"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIconButtonStyles = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var commons_1 = require("../../../style/commons");
var containedBaseStyles = function (backgroundHover, color, backgroundColor) {
    if (color === void 0) { color = 'white'; }
    if (backgroundColor === void 0) { backgroundColor = 'none'; }
    return ({
        color: color,
        backgroundColor: backgroundColor,
        borderRadius: 4,
        '&:hover': {
            backgroundColor: backgroundHover,
        },
    });
};
exports.useIconButtonStyles = (0, core_1.makeStyles)(function () { return ({
    extraSmall: {
        width: 24,
        height: 24,
        fontSize: 16,
    },
    small: {
        width: 32,
        height: 32,
        fontSize: 20,
    },
    medium: {
        width: 40,
        height: 40,
        fontSize: 24,
    },
    fullWidth: {
        width: '100%',
        height: '100%',
    },
    containedPrimary: tslib_1.__assign({}, containedBaseStyles(commons_1.mediumPrimary, 'white', 'none')),
    containedSecondary: tslib_1.__assign(tslib_1.__assign({}, containedBaseStyles(commons_1.secondaryColor, commons_1.darkPrimary, commons_1.lightSecondary)), { border: '1px solid', borderColor: commons_1.darkPrimary, '&:hover': {
            backgroundColor: commons_1.secondaryHover,
            borderColor: commons_1.brandPrimaryDarkAlternative,
        }, '&:focus': {
            borderColor: commons_1.darkSecondary,
            backgroundColor: commons_1.secondaryColor,
        } }),
    containedTertiary: tslib_1.__assign(tslib_1.__assign({}, containedBaseStyles(commons_1.secondaryColor, commons_1.darkPrimary, commons_1.lightSecondary)), { border: '1px solid transparent', backgroundColor: 'transparent', '&:hover': {
            backgroundColor: commons_1.secondaryHover,
            borderColor: commons_1.secondaryLineHover,
            border: '1px solid',
        }, '&:focus': {
            backgroundColor: commons_1.secondaryColor,
            borderColor: commons_1.darkSecondary,
        } }),
    textPrimary: tslib_1.__assign(tslib_1.__assign({}, containedBaseStyles(commons_1.brandPrimaryExtraDark, commons_1.brandPrimaryExtraDark, '')), { '&:hover': {
            color: commons_1.white,
            backgroundColor: commons_1.brandPrimaryExtraDark,
        } }),
    textSecondary: tslib_1.__assign({}, containedBaseStyles(commons_1.lightBlue, commons_1.darkSecondary)),
    textTertiary: tslib_1.__assign(tslib_1.__assign({}, containedBaseStyles(commons_1.lightBlue, commons_1.brandPrimaryMaxDark)), { '&:hover': {
            border: "1px solid ".concat(commons_1.brandPrimaryDarkAlternative),
            backgroundColor: commons_1.secondaryHover,
        }, '&:focus': {
            backgroundColor: commons_1.secondaryColor,
            border: "1px solid ".concat(commons_1.darkSecondary),
        } }),
    disabledContainedPrimary: {
        opacity: '0.4',
        backgroundColor: "".concat(commons_1.brandPrimaryExtraDark, " !important"),
        color: 'white !important',
    },
    disabledContainedSecondary: {
        opacity: '0.4',
        borderColor: '#7373FC',
        backgroundColor: "".concat(commons_1.white, " !important"),
        color: "".concat(commons_1.mediumSecondary, " !important"),
    },
    disabledContainedTertiary: {
        opacity: '0.4',
        backgroundColor: "".concat(commons_1.white, " !important"),
        color: "".concat(commons_1.mediumSecondary, " !important"),
    },
}); });
